import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

import { IntroDriveCountStep } from './introdrivecount.step';

/**
 * Ask user if they are a good driver
 */
export const IntroGoodDriverStep: Step = {
  id: 'introGoodDriver',
  pathname: '/introgooddriver',
  excludeFromProgressCalculation: true,
  canShow: (appData) => !appData.isOnboardingLite && IntroDriveCountStep.canShow(appData),
  hasData: () => true,
  hasOwnData: (appData) => !!appData.introGoodDriver,
  category: () => StepCategory.Intro,
};
